import React, { useState } from 'react';
import { Typography, Box, Card } from '@mui/material';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../../constants';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');
const VISIBLE_COUNT = 4;

const RecentReleasesCard = ({ updates }) => {
    const [isExpanded, setExpanded] = useState(false);

    if (updates.length === 0) return null;

    const primaryUpdates = updates.slice(0, VISIBLE_COUNT);
    const extraUpdates = updates.slice(VISIBLE_COUNT);
    const canExpand = extraUpdates.length > 0;

    const renderItem = (release, hasLineAfter) => (
        <Box key={release?.slug || release?.id || `${release?.title}-${release?.release_date}`} className="whats-new-recent-item">
            <Box className="whats-new-recent-timeline">
                <Box className="whats-new-recent-dot" />
                {hasLineAfter && <Box className="whats-new-recent-line" />}
            </Box>
            <Box className="whats-new-recent-content">
                <Typography className="whats-new-recent-date">{moment(release.release_date).format(dateMonthYearDateFormat)}</Typography>
                <Typography className="whats-new-recent-name">{release.title}</Typography>
            </Box>
        </Box>
    );

    return (
        <Card elevation={0} className="whats-new-recent-card">
            <Box className="whats-new-recent-header">
                <Typography className="whats-new-recent-title">Recent releases</Typography>
                {canExpand ? (
                    <Box component="button" type="button" onClick={() => setExpanded(prev => !prev)} className={cx('whats-new-recent-view-all', isExpanded && 'is-expanded')}> {isExpanded ? 'Show less' : 'View all'} </Box>
                ) : null}
            </Box>
            <Box className="whats-new-recent-list">
                {primaryUpdates.map((release, index) => renderItem(release, index < primaryUpdates.length - 1 || (canExpand && isExpanded)))}
                {canExpand ? (
                    <Box className={cx('whats-new-recent-list-extra', isExpanded && 'is-expanded')}>
                        <Box className="whats-new-recent-list-extra-inner">
                            {extraUpdates.map((release, index) => renderItem(release, index < extraUpdates.length - 1))}
                        </Box>
                    </Box>
                ) : null}
            </Box>
        </Card>
    );
};

export default RecentReleasesCard;
